import React from 'react';
import '../../utility/csrf';
import AmountWrapper from '../../components/amountWrapper';
import NextButton from '../../components/nextButton';
import OneTouchNextButton from '../../components/landing/OneTouchNextButton';
import CancelAndReturn from '../../components/cancelAndReturn';
import GuestButton from '../../components/guestButton';
import RecurringCheckBox from '../../components/recurring-checkbox/recurring-checkbox';
import UserDetailsBanner from '../../components/onetouch/UserDetailsBanner';
import OfferDetail from '../../components/offerDetail';
import Disclaimer from '../../components/Disclaimer';
import VoucherFlowDisclaimer from '../../components/voucherFlowDisclaimer';
import CloseButton from '../../components/CloseButton';
import ReceiverEligibilityErrorTile from '../error/receiverEligibilityError';
import {
  isInContext,
  isMobileOrInContext,
} from '../../utility/inContextDonation';
import DonateHeader from '../../components/common/DonateHeader';

import templateData from '../../utility/getTemplateData';
import {
  hasPersonalizedMessages,
  getPersonalizedMessages,
} from '../../utility/personalizedMessages';

import AppStore from '../../stores/AppStore';
import * as AppActions from '../../actions/AppActions';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import * as cpl from '../../utility/cpl';
import { GN_CONTENT_TOUCHPOINT } from '../../utility/constants';

import {
  handleLogIn,
  addShake,
  handleTokenReuse,
  hideSpinnerOverlay,
  getPPCCStatus,
  showSpinnerOverlay,
} from '../../utility/helper';
import {
  isAuthenticatedUser,
  shouldShowUserBanner,
  isLoggedInUser,
} from '../../utility/authUtils';
import * as amountUtils from '../../components/amount/amountUtils';

import { withRouter } from 'react-router-dom';
import * as FPT from '../../utility/fpt';
import {
  localsMessages,
  isOldButtonFactory,
  hasPartnerSource,
} from '../../utility/getTemplateData';
import { loadBodyMovin } from '../../utility/lazyLoader';
import _isEmpty from 'lodash/isEmpty';
import ProgramsContainer from '../../components/programs/ProgramsContainer';
import RecurringOverlay from '../../components/recurring-checkbox/RecurringOverlay';
import _get from 'lodash/get';
import NotTaxDeductibleLegalText from '../../components/NotTaxDeductibleLegalText';
import { getParameterByName } from '../../utility/queryStringHelper';
import CoverFeeCheckbox from '../../components/coverFee/coverFeeCheckbox';
import {
  computeAmountAfterFee,
  isOptInCoverFee,
  restoreDonationAmount,
  updateDonationAmount,
  setFeeAmountInStore,
} from '../../components/coverFee/feeUtils';
import { normalizeNumber } from '../../utility/formator';
import withDonate from '../../components/guest/WithDonate';
import AnonymousCheckbox from '../../components/anonymousDonation/anonymousCheckbox';
import {
  getPersonalizedAnonymousContent,
  getPersonalizedNoteToPayeeLabel,
  isCheckoutRail,
  isExternalFlow,
  prepareOrderParams,
} from '../../utility/externalIntegrationUtils';
import NoteComponent from '../../components/note';
import isEmpty from 'lodash/isEmpty';
import { EVENT_NAME } from '../../utility/constants';

const messages = localsMessages('common/amount');
const errorMessages = localsMessages('errors/landingerror');
const MERCHANT_PPCC_CONFIRMED_STATUS = 'CONFIRMED';

class LandingPageComponent extends React.Component {
  constructor(props) {
    super(props);
    const optInStatus = AppStore.getCoverFeeOptInStatus();
    const anonymousStatusInStore = AppStore.getAnonymousStatus();
    const anonymousOptInStatus = !isEmpty(anonymousStatusInStore)
      ? anonymousStatusInStore === 'checked'
      : templateData.anonymousStatus || false;

    this.state = {
      hasLogo: templateData.hasLogo,
      subHeaderLabel: templateData.donationName,
      orgName: templateData.charityName,
      donationId: templateData.donationId,
      guestRedirectUrl: templateData.guestRedirectUrl,
      donateDisabled: false,
      recurringEnabled: templateData.recurringEnabled,
      recurringStatus: templateData.recurringStatus === 'checked',
      recurringHelpText: '',
      recurringLabel: 'Make this a monthly donation',
      rpContinue: false,
      isAuthenticated: isAuthenticatedUser(),
      memberMandatory: templateData.memberMandatory,
      programNames: templateData.donateContext.program_names,
      isRecurringOverlayOpen: false,
      isVoucherFlow: templateData.isVoucherFlow,
      offerProgram: templateData.offerProgram,
      coverFeeEnabled: templateData.coverFeeEnabled,
      coverFeeOptInStatus:
        optInStatus !== undefined
          ? optInStatus === 'checked'
          : templateData.feePayer === 'consumer',
      feeAmount: '',
      formatedFeeAmount: '',
      anonymousEnabled: templateData.anonymousEnabled,
      anonymousOptInStatus,
      hasDisclaimer: hasPersonalizedMessages(GN_CONTENT_TOUCHPOINT),
    };
  }

  getPPCCConfirmation() {
    return getPPCCStatus() === MERCHANT_PPCC_CONFIRMED_STATUS;
  }

  componentDidMount() {
    window.onload = function () {
      setTimeout(function () {
        cpl.logPerformance({
          action: 'landing_page_loaded',
          uicomp: 'landingPageComponent',
          uitype: 'page',
          page: 'main:donate:wps::landing:landingPageComponent:web::',
        });
      }, 0);
    };

    AppActions.updateCurrentPage({ currentPage: 'landing' });

    // Do not hide spinner if coming to page with already completed payment token
    if (templateData.paymentStatus !== 'complete') {
      hideSpinnerOverlay();
    }

    // Checking for recurring status if coming from guest page
    if (AppStore.getDonationRecurring() === 'checked') {
      this.setState({ recurringStatus: true });
    }

    // Checking for cover fee preference if coming from guest page
    if (isOptInCoverFee()) {
      this.setState({ coverFeeOptInStatus: true });
      restoreDonationAmount();
    }

    setFeeAmountInStore();
    this.updateFeeAmount();

    // Pre-load bodyMovin
    if (templateData.recurringEnabled) {
      loadBodyMovin();
    }

    this.addTracking();

    if (templateData.anonymousEnabled) {
      FPT.trackAnonymousData();
    }

    if (!isLoggedInUser()) {
      AppActions.showLanguageSelector(true);
    }

    // Register for App Dispatcher Messages
    this.registerAppDispatcherMessages();
  }

  addTracking() {
    FPT.trackIntegrationType();
    FPT.trackNoteData({ noteFieldDisplayed: this.shouldShowNote() });
    FPT.trackAmountEditability();

    if (isExternalFlow()) {
      FPT.trackEventName(EVENT_NAME.DW_GIVING_DONATE_SETUP_SCREEN_SHOWN);
      FPT.trackExternalFlowData();
    }
  }

  componentWillUnmount() {
    AppDispatcher.unregister(this.dispatcherMessages);
  }

  registerAppDispatcherMessages() {
    this.dispatcherMessages = AppDispatcher.register((payload) => {
      if (payload.action && payload.action.actionType === 'CHANGE_RECURRING') {
        const checked = _get(payload.action, 'item', 'unchecked');
        this.setState({
          recurringStatus: checked === 'checked',
        });
      }
    });
  }

  getFPTDATA = () => {
    return {
      amount: AppStore.getDonationAmount(),
      code: AppStore.getDonationCode(),
      symbol: AppStore.getDonationSymbol(),
    };
  };

  validateAmountAndNavigateToGuestPage = () => {
    let donationAmount = AppStore.getDonationAmount();

    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      this.props.history.push(`/donate/guest?token=${templateData.token}`);
    } else {
      addShake();
    }
  };

  handleGuest = (event) => {
    event.preventDefault();
    AppActions.changeRecurringModalStatus({
      recurringModalStatus: 'notclosed',
    });
    let donationAmount = this.getDonationAmount();
    if (!this.validateDonationAmount()) {
      return;
    }

    if (templateData.coverFeeEnabled) {
      FPT.trackFeeData();
    }
    if (templateData.anonymousEnabled) {
      FPT.trackAnonymousData();
    }
    if (isExternalFlow()) {
      FPT.trackNoteData();
    }

    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      const isRecurringChecked = this.state.recurringStatus;

      if (isRecurringChecked && !this.state.memberMandatory) {
        this.openRecurringOverlay();
      } else {
        this.validateAmountAndNavigateToGuestPage();
      }

      FPT.trackDonationAmount();
      // Tracking click event with data. 'Pay by card with amount'
      if (isExternalFlow()) {
        FPT.trackLinkClickWithData('donateWithCard', {
          event_name:
            EVENT_NAME.DW_GIVING_DONATE_SETUP_DONATE_WITH_CARD_PRESSED,
        });
      } else {
        FPT.trackLinkClick('donateWithCard');
      }

      // Start CPL tracking to get measurements to load guest form
      window.PAYPAL.analytics.startCPLTracking({
        page: 'main:donate:wps:guest:guestform:guestFormComponent:web::',
        action: 'guest_form_loaded',
        uicomp: 'guestForm',
        uitype: 'component',
      });
    }
  };

  handleNext = (event) => {
    event.preventDefault();
    if (!this.validateDonationAmount()) {
      return;
    }

    let donationAmount = this.getDonationAmount(),
      normalizedAmount = normalizeNumber(donationAmount);

    if (templateData.coverFeeEnabled) {
      FPT.trackFeeData();
    }
    if (templateData.anonymousEnabled) {
      FPT.trackAnonymousData();
    }
    if (isExternalFlow()) {
      FPT.trackNoteData();
    }

    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      if (isExternalFlow()) {
        FPT.trackDonationAmount();
        FPT.trackLinkClickWithData('donateWithPayPal', {
          event_name: EVENT_NAME.DW_GIVING_DONATE_SETUP_NEXT_PRESSED,
        });
      } else {
        FPT.trackLinkClick('donateWithPayPal');
      }
    }
    FPT.addDonationAmount(normalizedAmount, window.fpti.pgrp, window.fpti.page);

    handleLogIn();
  };

  handleNextForCheckout = (event) => {
    event.preventDefault();
    if (!this.validateDonationAmount()) {
      return;
    }

    let donationAmount = AppStore.getDonationAmount();

    FPT.trackNoteData();
    if (templateData.anonymousEnabled) {
      FPT.trackAnonymousData();
    }
    FPT.addDonationAmount(donationAmount, window.fpti.pgrp, window.fpti.page);
    FPT.trackLinkClickWithData('donateViaCheckout', {
      event_name: EVENT_NAME.DW_GIVING_DONATE_SETUP_NEXT_PRESSED,
    });

    showSpinnerOverlay();
    const orderParams = prepareOrderParams();
    this.props.createOrder(orderParams);
  };

  getDonationAmount = () => {
    let donationAmount = AppStore.getDonationAmount();

    if (isOptInCoverFee()) {
      const feeAmount = AppStore.getFeeAmount();
      // backup user's original entered amount in store
      AppActions.changeAmountBeforeFee({ amountBeforeFee: donationAmount });

      if (feeAmount) {
        donationAmount = computeAmountAfterFee(donationAmount, feeAmount);
        updateDonationAmount(donationAmount);
      }
    }

    return donationAmount;
  };

  hideValidationError = () => {
    this.setState({
      showValidationError: false,
    });
  };

  validateDonationAmount = () => {
    let validationResult = amountUtils.validateMinimumDonationAmount(messages);
    if (validationResult?.showValidationError) {
      this.setState(validationResult);
      addShake();
      return false;
    }

    validationResult = amountUtils.validateMaximumDonationAmount();
    if (validationResult?.showValidationError) {
      this.setState(validationResult);
      addShake();
      return false;
    }

    this.setState(validationResult);
    return true;
  };

  handleAmountFocus = () => {
    if (this.state.showValidationError) {
      this.hideValidationError();
    }
  };

  updateConversionSataus = (status = false) => {
    this.setState({ donateDisabled: status });
  };

  handleRecurringChange = (status = false) => {
    this.setState({ recurringStatus: status });
    console.log('status ', status);
  };

  handleRecurringOverlayContinue = () => {
    this.setState({ rpContinue: true });
    this.validateAmountAndNavigateToGuestPage();
  };

  handleRecurringOverlayMakeOneTimeDonation = () => {
    AppActions.changeRecurring({
      recurring: 'unchecked',
    });
    this.validateAmountAndNavigateToGuestPage();
  };

  handleAnonymousDonationChange = (status = false) => {
    this.setState({ anonymousOptInStatus: status });
    FPT.trackDonationAmount();
    FPT.trackLinkClickWithData('anonymous_checkbox', {
      checkbox: status,
      nonanonymous: !status,
      event_name: status
        ? EVENT_NAME.DW_GIVING_DONATE_SETUP_SHARE_CONTACT_CHECK_PRESSED
        : EVENT_NAME.DW_GIVING_DONATE_SETUP_SHARE_CONTACT_UNCHECK_PRESSED,
    });
  };

  handleCoverFeeChange = (status = false) => {
    this.setState({ coverFeeOptInStatus: status });
    FPT.trackFeeData();
    FPT.trackLinkClickWithData('cover_fee_checkbox', { checkbox: status });
  };

  updateFeeAmount = () => {
    this.setState({
      feeAmount: AppStore.getFeeAmount(),
      formatedFeeAmount: AppStore.getFormatedFeeAmount(),
    });
  };

  openRecurringOverlay = () => {
    this.setState({
      isRecurringOverlayOpen: true,
    });
  };

  closeRecurringOverlay = () => {
    this.setState({
      isRecurringOverlayOpen: false,
    });
  };

  renderProgramsDropdown = () => {
    if (isOldButtonFactory() || _isEmpty(this.state.programNames)) {
      return null;
    }

    return <ProgramsContainer programNames={this.state.programNames} />;
  };

  renderDonateButtons = () => {
    if (isCheckoutRail()) {
      return (
        <OneTouchNextButton
          disabled={false}
          handleNext={this.handleNextForCheckout}
        />
      );
    }

    if (this.state.isAuthenticated) {
      return (
        <OneTouchNextButton
          disabled={this.state.donateDisabled}
          handleNext={this.handleNext}
        />
      );
    }

    return (
      <div>
        <div className="mb-16">
          <NextButton
            disabled={this.state.donateDisabled}
            handleNext={this.handleNext}
          />
        </div>
        <GuestButton
          disabled={this.state.donateDisabled}
          handleGuest={this.handleGuest}
        />
      </div>
    );
  };

  /**
   * Should show note on landing page when charityNote is enabled
   * and recurring is disabled for client flows
   * @return {Boolean} true to show note field
   */
  shouldShowNote = () => {
    return (
      templateData.charityNoteEnabled &&
      !this.state.recurringStatus &&
      isExternalFlow()
    );
  };

  getPersonalizedContent = () => {
    if (isExternalFlow()) {
      const personalizedMessages = getPersonalizedMessages(
        GN_CONTENT_TOUCHPOINT
      );
      return personalizedMessages?.disclaimer;
    }
  };

  landingClass = () => {
    let className = '';
    if (isExternalFlow()) {
      className = 'gn_donate_wrapper ';
    } else {
      className = 'donate_wrapper ';
    }
    if (isInContext()) {
      className += 'context_gn_wrapper ';
    }
    if (shouldShowUserBanner()) {
      className += 'user-banner ';
    }
    if (isMobileOrInContext()) {
      className += 'mobile_view ';
    }

    return className;
  };

  render() {
    const showUserBanner = shouldShowUserBanner();

    if (!templateData.receiverCountryEligible) {
      return (
        <div
          className={`donate_wrapper receiver-eligibility-error-container ${
            isMobileOrInContext() ? 'mobile_view' : ''
          }`}
        >
          <ReceiverEligibilityErrorTile
            errorMessages={errorMessages}
            organizationName={templateData.donationName}
            returnUrl={templateData.charityReturnUrl}
          />
        </div>
      );
    }

    return (
      <div>
        <div className={this.landingClass()}>
          {showUserBanner ? (
            <UserDetailsBanner userDetails={templateData.userDetails} />
          ) : null}
          {isExternalFlow() && <CloseButton />}
          <DonateHeader />
          <div className="container">
            <AmountWrapper
              conversionStatus={this.updateConversionSataus}
              validateDonationAmount={this.validateDonationAmount}
              showValidationError={this.state.showValidationError}
              hideValidationError={this.hideValidationError}
              validationErrorMessage={this.state.validationErrorMessage}
              validationErrorCode={this.state.validationErrorCode}
              onFocus={this.handleAmountFocus}
              updateFeeAmount={this.updateFeeAmount}
            />
            {this.renderProgramsDropdown()}
            {this.state.recurringEnabled && (
              <RecurringCheckBox
                status={this.state.recurringStatus}
                handleChange={this.handleRecurringChange}
                showNote={false}
                hasRecurringHelp={true}
                continue={this.state.rpContinue}
              />
            )}
            {this.state.anonymousEnabled && (
              <AnonymousCheckbox
                content={getPersonalizedAnonymousContent()}
                optInStatus={this.state.anonymousOptInStatus}
                handleAnonymousDonationChange={
                  this.handleAnonymousDonationChange
                }
              />
            )}
            {this.shouldShowNote() && (
              <NoteComponent label={getPersonalizedNoteToPayeeLabel()} />
            )}
            {this.state.coverFeeEnabled && (
              <CoverFeeCheckbox
                handleCoverFeeChange={this.handleCoverFeeChange}
                optInStatus={this.state.coverFeeOptInStatus}
                formatedFeeAmount={this.state.formatedFeeAmount}
              />
            )}
            {this.state.isVoucherFlow && (
              <OfferDetail
                offerProgram={this.state.offerProgram}
                success={false}
              />
            )}
            {this.renderDonateButtons()}
            {this.state.isVoucherFlow && <VoucherFlowDisclaimer />}
            {hasPartnerSource() &&
              !this.getPPCCConfirmation() &&
              !this.state.isVoucherFlow && <NotTaxDeductibleLegalText />}
            <RecurringOverlay
              onContinue={this.handleRecurringOverlayContinue}
              onMakeOneTimeDonation={
                this.handleRecurringOverlayMakeOneTimeDonation
              }
              isOpen={this.state.isRecurringOverlayOpen}
              openRecurringOverlay={this.openRecurringOverlay}
              closeRecurringOverlay={this.closeRecurringOverlay}
            />
            {this.state.hasDisclaimer && (
              <div
                style={{
                  marginTop: '12px',
                }}
              >
                <Disclaimer content={this.getPersonalizedContent()} />
              </div>
            )}
          </div>
        </div>
        <CancelAndReturn />
      </div>
    );
  }
}

const LandingPage = withRouter(withDonate(LandingPageComponent));

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayLanding: !templateData.currentState,
    };
  }

  /**
   * For DIRECT(nonWebscr) and POST integrations, there will not be a token in the URL
   * This will break page refresh.
   * Hence adding token here
   */
  addTokenToUrlIfMissing() {
    const token = getParameterByName('token');
    const business = getParameterByName('business');
    const hostedButtonId = getParameterByName('hosted_button_id');

    if (!token && !business && !hostedButtonId) {
      this.props.history.replace({
        pathname: '/donate',
        search: `?token=${templateData.token}`,
      });
    }
  }

  componentDidMount() {
    if (!this.state.displayLanding) {
      this.props.history.push(templateData.currentState);
    } else {
      handleTokenReuse();
    }
    this.addTokenToUrlIfMissing();
  }

  render() {
    return <div>{this.state.displayLanding ? <LandingPage /> : null}</div>;
  }
}

export default withRouter(Landing);
